import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getThirdFlow = asyncThunkWrapper({ 
  model: 'thirdFlow', 
  action: 'getThirdFlow', 
  func: async () => {
    const attributes = ['id', 'email', 'prompt', 'updated_at'];
    const params = { attributes };
    const response = await axios.get(`/third_flow`, { params });

    return response.data;
  } 
});
export const createThirdFlow = asyncThunkWrapper({ 
  model: 'thirdFlow', 
  action: 'createThirdFlow', 
  func: async (third_flow) => {
    const attributes = ['id', 'email', 'prompt', 'updated_at'];
    const response = await axios.post(`/third_flow`, { third_flow, attributes });

    return response.data;
  } 
});
export const updateThirdFlow = asyncThunkWrapper({ 
  model: 'thirdFlow', 
  action: 'updateThirdFlow', 
  func: async (third_flow) => {
    const response = await axios.patch(`/third_flow`, { third_flow });

    return { status: response.status, third_flow };
  } 
});
export const deleteThirdFlow = asyncThunkWrapper({ 
  model: 'thirdFlow', 
  action: 'deleteThirdFlow', 
  func: async () => {
    const response = await axios.delete(`/third_flow`);

    return { status: response.status };
  } 
});
export const clearLocalActiveThirdFlow = createAction('thirdFlow/clearLocalActiveThirdFlow');